import { SvgIcon, SvgIconProps, SvgIconTypeMap } from '@material-ui/core';
import { OverridableComponent } from '@material-ui/core/OverridableComponent';

const LimeIcon: OverridableComponent<SvgIconTypeMap<{}, 'svg'>> = (
  props: SvgIconProps,
) => {
  return (
    <SvgIcon {...props}>
      <svg
        version="1.1"
        id="Layer_1"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 512 512"
      >
        <g>
          <g>
            <path
              d="M50.102,116.712c-3.545-2.255-8.244-1.204-10.495,2.34c-1.787,2.812-3.541,5.697-5.214,8.573
			c-2.112,3.629-0.88,8.283,2.75,10.395c1.203,0.699,2.518,1.032,3.816,1.032c2.619,0,5.169-1.355,6.58-3.782
			c1.573-2.705,3.223-5.418,4.904-8.062C54.695,123.664,53.646,118.963,50.102,116.712z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M396.781,460.875c-2.279-3.528-6.986-4.54-10.514-2.262C347.594,483.59,302.548,496.792,256,496.792
			c-64.318,0-124.786-25.046-170.266-70.527C40.254,380.787,15.208,320.318,15.208,256c0-35.252,7.377-69.134,21.925-100.707
			c1.757-3.814,0.09-8.331-3.724-10.088c-3.816-1.759-8.332-0.09-10.088,3.724C7.846,182.51,0,218.534,0,256
			c0,68.381,26.629,132.668,74.981,181.02C123.332,485.371,187.619,512,256,512c49.483,0,97.381-14.044,138.519-40.612
			C398.046,469.11,399.06,464.402,396.781,460.875z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M437.02,74.981C388.667,26.629,324.379,0,256,0S123.332,26.629,74.981,74.981c-7.925,7.925-15.383,16.411-22.167,25.222
			c-2.562,3.328-1.942,8.102,1.387,10.664c3.326,2.562,8.102,1.942,10.664-1.386c6.384-8.293,13.406-16.282,20.869-23.745
			C131.214,40.255,191.682,15.208,256,15.208c64.317,0,124.786,25.046,170.266,70.527c45.48,45.478,70.526,105.946,70.526,170.265
			s-25.046,124.787-70.527,170.266c-6.684,6.685-13.804,13.029-21.161,18.854c-3.293,2.607-3.849,7.389-1.242,10.681
			c1.5,1.896,3.723,2.884,5.967,2.884c1.654,0,3.318-0.536,4.714-1.642c7.816-6.188,15.377-12.924,22.476-20.022
			C485.371,388.668,512,324.381,512,256S485.371,123.332,437.02,74.981z"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M414.951,97.049c-42.457-42.458-98.908-65.84-158.952-65.84c-60.044,0-116.494,23.381-158.951,65.839
			c-42.458,42.457-65.84,98.908-65.84,158.951c0,60.043,23.383,116.495,65.84,158.952c42.457,42.458,98.907,65.84,158.951,65.84
			c60.044,0,116.495-23.383,158.952-65.84c42.458-42.457,65.84-98.908,65.84-158.951S457.409,139.506,414.951,97.049z M256,465.583
			c-115.564,0-209.584-94.018-209.584-209.583S140.435,46.416,256,46.416S465.584,140.434,465.584,256S371.564,465.583,256,465.583z
			"
            />
          </g>
        </g>
        <g>
          <g>
            <path
              d="M433.196,190.889c-0.004-0.004-0.008-0.007-0.011-0.01l-0.302-0.291c-0.165-0.159-0.338-0.311-0.516-0.454l-0.342-0.275
			c-1.086-0.868-3.09-2.283-5.915-3.528c1.917-4.115,2.403-7.546,2.513-8.607l0.031-0.306c0.019-0.18,0.03-0.359,0.036-0.539
			l0.01-0.3c0.391-11.766-1.388-41.824-26.302-66.738c-23.129-23.129-50.035-26.582-64.014-26.582c-0.466,0-0.919,0.003-1.35,0.011
			l-0.421,0.007c-0.239,0.004-0.478,0.019-0.715,0.046l-0.425,0.048c-3.299,0.369-6.551,1.402-9.579,2.989
			c-1.364-2.955-2.82-4.876-3.342-5.517l-0.194-0.238c-0.112-0.139-0.231-0.275-0.354-0.405l-0.203-0.216
			c-8.042-8.598-30.551-28.594-65.788-28.594c-34.719,0-57.03,19.183-65.017,27.437l-0.292,0.302
			c-0.162,0.168-0.317,0.345-0.463,0.527l-0.269,0.335c-1.424,1.781-2.616,3.782-3.554,5.931c-4.144-1.94-7.604-2.426-8.669-2.535
			l-0.306-0.031c-0.17-0.018-0.343-0.029-0.514-0.035l-0.331-0.012c-0.872-0.027-1.799-0.046-2.772-0.046
			c-14.047,0-41.035,3.423-63.958,26.345c-24.547,24.547-26.761,53.89-26.573,65.376l0.007,0.42
			c0.004,0.236,0.019,0.471,0.046,0.706l0.047,0.425c0.336,2.995,1.36,6.502,3.244,9.979c-2.964,1.327-4.962,2.801-5.833,3.508
			l-0.238,0.195c-0.13,0.105-0.255,0.216-0.379,0.331l-0.229,0.214c-8.597,8.043-28.593,30.553-28.593,65.789
			c0.002,34.717,19.185,57.03,27.439,65.016l0.301,0.291c0.168,0.162,0.343,0.316,0.525,0.462l0.338,0.271
			c1.068,0.854,3.021,2.236,5.77,3.464c-1.776,3.958-2.233,7.219-2.336,8.223l-0.031,0.307c-0.018,0.175-0.029,0.351-0.035,0.526
			l-0.01,0.311c-0.392,11.765,1.384,41.822,26.301,66.737c23.13,23.13,50.036,26.584,64.02,26.584c0.465,0,0.916-0.003,1.346-0.011
			l0.421-0.007c0.245-0.004,0.49-0.02,0.733-0.048l0.404-0.046c2.976-0.333,6.469-1.351,9.942-3.228
			c1.388,3.075,2.903,5.076,3.446,5.745l0.195,0.241c0.116,0.142,0.236,0.28,0.362,0.414l0.203,0.217
			c8.043,8.597,30.555,28.593,65.788,28.593c34.714,0,57.029-19.183,65.014-27.433l0.291-0.301c0.167-0.174,0.327-0.356,0.479-0.544
			l0.255-0.32c1.382-1.728,2.548-3.67,3.477-5.758c3.979,1.796,7.264,2.256,8.277,2.36l0.306,0.031
			c0.171,0.018,0.344,0.029,0.515,0.035l0.331,0.012c0.872,0.028,1.796,0.046,2.768,0.046c14.047,0,41.038-3.423,63.964-26.347
			c24.548-24.549,26.761-53.89,26.572-65.367l-0.007-0.42c-0.004-0.239-0.019-0.48-0.046-0.717l-0.048-0.421
			c-0.372-3.33-1.415-6.604-3.022-9.65c2.819-1.293,4.723-2.7,5.561-3.381l0.238-0.195c0.139-0.113,0.274-0.23,0.402-0.352
			l0.217-0.204c8.596-8.043,28.593-30.553,28.593-65.787C460.627,221.18,441.443,198.869,433.196,190.889z M328.471,103.386
			c2.796-3.184,6.315-4.636,8.691-4.903l0.133-0.008c0.355-0.006,0.718-0.009,1.093-0.009c11.627,0,34.007,2.875,53.26,22.128
			c20.703,20.704,22.181,45.696,21.856,55.489l-0.005,0.071c-0.021,0.198-0.53,4.44-4.241,8.098l-127.175,52.598
			c-10.667,4.413-6.23-6.23-6.23-6.23L328.471,103.386z M201.85,89.49l0.084-0.096c6.633-6.856,25.182-22.799,54.082-22.799
			c29.282,0,47.995,16.625,54.689,23.783l0.048,0.054c0.12,0.149,2.803,3.554,2.729,8.823l-52.618,126.932
			c-4.421,10.664-8.811,0-8.811,0L199.158,97.704C199.237,94.073,200.544,91.126,201.85,89.49z M120.626,120.359
			c20.351-20.351,44.612-22.2,55.463-21.856l0.105,0.008c0.193,0.02,4.153,0.495,7.715,3.868
			c9.195,22.025,53.138,127.399,53.138,127.399c4.413,10.667-6.23,6.23-6.23,6.23l-128.283-53.315
			c-2.564-2.616-3.777-5.658-4.021-7.847l-0.008-0.125C98.35,165.183,100.193,140.792,120.626,120.359z M89.475,310.714
			l-0.097-0.085c-6.855-6.634-22.799-25.183-22.799-54.082c0-29.28,16.626-47.995,23.771-54.679l0.066-0.06
			c0.137-0.111,3.41-2.72,8.62-2.72c0.421,0,0.919,0.034,1.478,0.089l125.825,52.363c10.664,4.421,0,8.811,0,8.811L97.773,313.43
			C93.021,313.347,90.025,311.154,89.475,310.714z M183.393,408.783c-2.758,3.056-6.156,4.468-8.542,4.735l-0.114,0.007
			c-0.353,0.006-0.714,0.009-1.093,0.009c-11.627,0-34.007-2.875-53.262-22.131c-20.705-20.704-22.181-45.693-21.855-55.474
			l0.006-0.09c0.021-0.2,0.56-4.712,4.6-8.439c0.01,0.017,0.019,0.03,0.019,0.03l126.817-52.596c10.667-4.413,6.23,6.23,6.23,6.23
			L183.393,408.783z M313.364,413.362c0.15,4.058-1.303,7.39-2.719,9.161l-0.071,0.082c-6.636,6.855-25.187,22.799-54.083,22.799
			c-29.278,0-47.994-16.626-54.69-23.783l-0.022-0.024l-0.026-0.032c-0.118-0.146-2.566-3.249-2.726-8.109l52.629-127.958
			c4.421-10.664,8.811,0,8.811,0l52.481,126.669c0.04,0.096,0.204,0.126,0.463,0.102
			C313.371,412.628,313.35,412.993,313.364,413.362z M391.412,391.641c-20.35,20.349-44.609,22.21-55.463,21.857l-0.1-0.007
			c-0.21-0.022-5.195-0.604-9.017-5.246c-0.241-0.293-0.505-0.56-0.781-0.808c0.572-0.253,0.91-0.407,0.91-0.407l-51.953-125.125
			c-4.413-10.667,6.23-6.23,6.23-6.23l127.169,52.837c0.112,0.047,0.228,0.076,0.347,0.099c3.078,2.772,4.508,6.196,4.769,8.544
			l0.008,0.122C413.688,346.816,411.846,371.205,391.412,391.641z M421.638,310.59l-0.057,0.05c-0.13,0.105-3.107,2.471-7.892,2.697
			c-0.022-0.009-0.042-0.021-0.065-0.029L285.68,260.583c-10.664-4.421,0-8.811,0-8.811l126.66-52.409
			c0.206-0.085,0.392-0.199,0.571-0.323c0.039-0.002,0.078,0.005,0.118,0.002c0.309-0.019,0.616-0.031,0.926-0.031
			c4.912,0,8.01,2.275,8.565,2.72l0.113,0.098c6.86,6.641,22.79,25.184,22.79,54.073
			C445.421,285.181,428.794,303.896,421.638,310.59z"
            />
          </g>
        </g>
      </svg>
    </SvgIcon>
  );
};

export default LimeIcon;
